import { render, staticRenderFns } from "./PostDisplay.vue?vue&type=template&id=ec74e776&"
import script from "./PostDisplay.vue?vue&type=script&lang=js&"
export * from "./PostDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports